import React from "react";
import CommonRow from "../common-row";
const TenStories2AdWithLoadMore = props => {
  return <CommonRow {...props} />;
};

export default TenStories2AdWithLoadMore;
